import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import '../../styles/PartnerWithUs.css';

const bulletPoints = [
  'Do you thrive on the satisfaction of helping people achieve homeownership?',
  'Does the freedom of flexible work hours appeal to you?',
  'Do you like the idea of earning as much income as you can, as early as possible?',
];

function PartnerMotivationSection() {
  return (
    <section className="partnerMotivation">
      <h2 className="highlightedHeader">Become a Property Agent? Why?</h2>
      <div className="bulletGrid">
        {bulletPoints.map((text, index) => (
          <div key={index} className="bulletItem">
            <CheckIcon className="checkIcon" />
            <span>{text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PartnerMotivationSection;
